import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const DRIPS = [
    [-.98, 5, .02, .95], [-.85, 7, .12, .86], [-.71, 4, .04, 1],
    [-.57, 6, .20, .78], [-.42, 4, .08, .9], [-.27, 5, .16, .96],
    [-.12, 4, .06, .84], [.05, 5, .19, .92], [.20, 6, .03, .83],
    [.36, 7, .22, 1], [.53, 4, .11, .88], [.68, 5, .06, .94],
    [.81, 4, .17, .81], [.96, 6, .09, .97],
];

/** A short decorative cascade, clipped to the hero and below all readable UI. */
export const WaterTopHalfOverlay = ({ burst, onComplete }) => {
    useEffect(() => {
        const finish = () => onComplete(burst.id);
        const visibility = () => { if (document.hidden) finish(); };
        const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const motionChanged = () => { if (preference.matches) finish(); };
        window.addEventListener('resize', finish);
        document.addEventListener('visibilitychange', visibility);
        preference.addEventListener('change', motionChanged);
        return () => {
            window.removeEventListener('resize', finish);
            document.removeEventListener('visibilitychange', visibility);
            preference.removeEventListener('change', motionChanged);
        };
    }, [burst.id, onComplete]);

    const spread = Math.min(burst.width * .42, 320);
    return <motion.div className="splash-water-theme water-tophalf-overlay" style={{ top: burst.y, height: burst.height }} aria-hidden="true" data-testid="water-tophalf-overlay"
        initial={{ opacity: 0 }} animate={{ opacity: [0, 1, .8, 0] }} transition={{ duration: 3.6, times: [0, .06, .66, 1] }} onAnimationComplete={() => onComplete(burst.id)}>
        {DRIPS.map(([direction, width, delay, distance], index) => <motion.span key={index} className="splash-fluid-drop water-cascade-drop" data-testid={`water-cascade-drop-${index}`}
            style={{ left: burst.x, width, height: width * 1.9 }} initial={{ x: 0, y: 0, opacity: 0 }}
            animate={{ x: [0, direction * spread * .42, direction * spread * .78, direction * spread], y: [0, burst.height * .10, burst.height * .42, burst.height * distance], opacity: [0, .22, .17, 0], scaleY: [1, 1.4, 1.9, .7] }}
            transition={{ duration: 3.05, delay: .12 + delay, times: [0, .25, .58, 1], ease: 'linear' }} />)}
    </motion.div>;
};
